module.exports = __webpack_public_path__ + "img/sms.b22abc86.svg";